import { Controller } from "@hotwired/stimulus"

// Attached to a hidden <iframe> that loads a sale's receipt. As soon as the
// receipt has rendered it opens the browser print dialog for that frame only,
// so the cashier stays on the POS screen while the receipt prints.
export default class extends Controller {
  connect() {
    const frame = this.element

    const printFrame = () => {
      frame.contentWindow.focus()
      frame.contentWindow.print()
    }

    const loaded = frame.contentDocument?.readyState === "complete" &&
                   frame.contentWindow.location.href !== "about:blank"

    if (loaded) {
      printFrame()
    } else {
      frame.addEventListener("load", printFrame, { once: true })
    }
  }
}
